<template>
    <div class="order-info page">
        <div class="order-detail">
            <div class="session-info">
                <div class="line-cinema">{{ detail.cinemaName }}</div>
                <div class="line-film-name">{{ detail.filmName }}</div>
                <div class="line-version-type">
                    {{ detail.versionTypes }} {{ detail.seatsCount }}张
                    {{ detail.acceptAdjust ? '同意调座' : '不同意调座' }}
                </div>
                <div class="info-box">
                    <div class="time">
                        <div class="line-show-date">
                            {{ detail.showDateOfChinese }} {{ detail.showDate }}
                        </div>
                        <div class="line-show-time">
                            {{ detail.showTimeHM }}~{{ detail.showEndTimeHM }}
                        </div>
                    </div>
                    <div class="seat">
                        <div class="line-hall-name">{{ detail.hallName }}</div>
                        <template v-if="!detail.adjusted">
                            <div class="seat-list">
                                <span
                                    class="seat-item"
                                    v-for="(item, index) in detail.seats"
                                    :key="index"
                                >
                                    {{ item.name }}
                                </span>
                            </div>
                        </template>
                        <template v-else>
                            <div class="seat-list">
                                <template v-for="couponList in couponImgs">
                                    <span
                                        class="seat-item"
                                        v-for="(item, index) in couponList.seats"
                                        :key="index"
                                    >
                                        {{ item.name }}
                                    </span>
                                </template>
                            </div>
                            <div class="seat-list mini">
                                (由原
                                <span
                                    class="seat-item"
                                    v-for="(item, index) in detail.seats"
                                    :key="index"
                                >
                                    {{ item.name }}
                                </span>
                                调座)
                            </div>
                        </template>
                    </div>
                </div>
                <img :src="detail.pic" class="film-img" />
            </div>
            <div class="dividing-line">
                <div class="line-item"></div>
            </div>
            <div class="tip-list" @click="showTip">
                <div class="tip-item">
                    <img src="@/assets/icons/icon-close-red.png" />
                    <span>不支持退票</span>
                </div>
                <div class="tip-item">
                    <img src="@/assets/icons/icon-close-red.png" />
                    <span>不支持改签</span>
                </div>
                <div class="tip-item">
                    <img src="@/assets/icons/icon-voice-red.png" />
                    <span>退改签须知</span>
                </div>
            </div>
            <div class="dividing-line">
                <div class="line-item"></div>
            </div>
            <div class="status-box" :class="'status-' + detail.status">
                <template v-if="detail.status == -5">
                    <div class="status-circular"></div>
                    <div class="status-title">已取消</div>
                    <!-- <div class="btn btn-next-buy">再次购买</div> -->
                </template>
                <template v-else-if="detail.status == 0">
                    <div class="status-circular">{{ payDownTimeText }}</div>
                    <div class="status-title">待支付</div>
                    <div class="status-tip">若超时未支付，订单将自动取消</div>
                    <div class="btn btn-next-buy" @click="payOrder">立即付款</div>
                </template>
                <template v-else-if="detail.status == 5">
                    <div class="status-circular"></div>
                    <div class="status-title">
                        {{ detail.supplierUserId ? '出票中' : '排队中' }}
                    </div>
                </template>
                <template v-else-if="detail.status == 10 || detail.status == 15">
                    <div class="status-title">取票码</div>
                    <div class="status-tip">
                        在
                        <span style="color:#F8C32F;">影院自助取票机</span>
                        扫码或输入上述内容领取电影票
                    </div>
                    <div class="swiper">
                        <img
                            class="seal"
                            src="~@/assets/images/image-order-status-15-block.png"
                            v-if="detail.status == 15"
                        />
                        <div class="swiper-container swiper-container-autoheight coupon-swiper">
                            <div class="swiper-wrapper">
                                <div
                                    class="swiper-slide"
                                    :class="{ 'swiper-slide-active': couponImgs.length == 1 }"
                                    v-for="(item, index) in couponImgs"
                                    :key="index"
                                >
                                    <img
                                        class="swiper-img"
                                        :src="item.couponCodeImageUrl"
                                        @click="showPreviewImage(item, index)"
                                        alt=""
                                    />
                                    <div class="code-info">
                                        <div class="item code-item">
                                            <div class="value">{{ item.couponCode }}</div>
                                            <div class="title">取票码</div>
                                        </div>
                                        <div class="item code-item" v-if="item.validCode">
                                            <div class="value">{{ item.validCode }}</div>
                                            <div class="title">验证码</div>
                                        </div>
                                    </div>
                                    <div class="seat-text">
                                        <template v-if="item.seats.length != 0">
                                            <span v-for="(v, i) in item.seats" :key="i">
                                                {{ v.name }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span v-for="(v, i) in detail.seats" :key="i">
                                                {{ v.name }}
                                            </span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="swiper-arrow prevs"
                            :class="{ 'no-click': imgCurrent == 0 }"
                            @click="prev"
                        ></div>
                        <div
                            class="swiper-arrow nexts"
                            :class="{ 'no-click': imgCurrent == couponImgs.length - 1 }"
                            @click="next"
                        ></div>
                    </div>
                    <div class="indicator-text">
                        共
                        <span class="prominent">{{ couponImgs.length }}</span>
                        张取票码，当前第
                        <span class="prominent">{{ imgCurrent + 1 }}</span>
                        张
                    </div>
                </template>
                <div class="update-time">
                    <p>
                        如若长时间未更新，请及时“
                        <span class="red">联系客服</span>
                        ”或点击右侧“
                        <span class="red">刷新</span>
                        ”按钮
                    </p>
                    <p>
                        更新时间：
                        <span class="red">{{ pageUpdateTime }}</span>
                        ~
                    </p>
                </div>
                <div class="btn-refresh" @click="refresh">刷新</div>
            </div>
            <div class="dividing-line">
                <div class="line-item"></div>
            </div>
            <div class="model price" :class="{ open: showPriceDetail }">
                <div class="line title">
                    <div class="line-title bold">实付金额：¥{{ detail.totalPrice }}</div>
                    <div class="line-value" @click="switchDetail">结算明细</div>
                </div>
                <div class="line">
                    <div class="line-title">原价</div>
                    <div class="line-value">¥{{ detail.marketUnitPrice }}</div>
                </div>
                <div class="line">
                    <div class="line-title">优惠价</div>
                    <div class="line-value bold">¥{{ detail.unitPrice }}</div>
                </div>
                <div class="line">
                    <div class="line-title">数量</div>
                    <div class="line-value">{{ detail.seatsCount }}</div>
                </div>
                <div class="line" v-if="(detail.saveAmount || 0) > 0">
                    <div class="line-title">已省</div>
                    <div class="line-value keynote">¥{{ detail.saveAmount || 0 }}</div>
                </div>
                <div class="line">
                    <div class="line-title">总价</div>
                    <div class="line-value bold">¥{{ detail.totalPrice }}</div>
                </div>
            </div>
            <div class="dividing-line">
                <div class="line-item"></div>
            </div>
            <div class="model information">
                <div class="line">
                    <div class="line-title">订单编号</div>
                    <div class="line-value secondary">
                        <span>{{ detail.orderNo }}</span>
                        <span
                            class="copy"
                            v-clipboard:copy="detail.orderNo"
                            v-clipboard:success="copySuccess"
                        >
                            复制
                        </span>
                    </div>
                </div>

                <div class="line">
                    <div class="line-title">购买时间</div>
                    <div class="line-value secondary">{{ detail.paymentTime || '未支付' }}</div>
                </div>

                <div class="line" v-if="detail.payTypeDesc">
                    <div class="line-title">支付方式</div>
                    <div class="line-value secondary">{{ detail.payTypeDesc }}</div>
                </div>

                <div class="line">
                    <div class="line-title">联系方式</div>
                    <div class="line-value secondary">{{ detail.userMobile }}</div>
                </div>

                <div class="line btn-list">
                    <!-- <div class="btn"
                         v-if="$store.getters.getExposeMethod.showOrderComplaintBtn && detail.paymentTime"
                         @click="complaint">投诉</div> -->
                    <div class="btn" v-if="detail.status == 5" @click="reminder">催单</div>
                    <div class="btn contact" @click="contact">联系客服</div>
                    <div class="btn" v-if="detail.status == 5" @click="cancelOrder">取消订单</div>
                </div>
            </div>
        </div>
        <div class="popup" v-if="showPopupStatus" @click="hideTip">
            <div class="tip-message iphone-x-adaptation" @click.stop="">
                <div class="title">退改签须知</div>
                <div class="content">
                    <p class="bold">关于退票：</p>
                    <p>
                        排队中的订单，您可以在首页电影-订单-点击进入后，自行申请取消订单，完成取消后我们将原路退回您的款项；出单中和已出票的订单不支持退票。
                    </p>
                    <p class="bold">关于改签：</p>
                    <p>
                        排队中的订单，您可以在首页电影-订单-点击进入后，自行申请取消订单，完成取消后我们将原路退回您的款项；出单中和已出票的订单不支持改签。
                    </p>
                </div>
                <img class="close" src="~@/assets/icons/icon-close.png" @click="hideTip" />
            </div>
        </div>
        <previewImage
            v-if="showImgStatus"
            :urls.sync="previewImageList"
            :index.sync="previewImageIndex"
            :change="previewImageChange"
        />
    </div>
</template>
<script>
import moment from 'moment';
import Swiper from '@/lib/swiper3.4.2/swiper.min.js';
import '@/lib/swiper3.4.2/swiper.min.css';
import previewImage from '@/components/previewImage';
import {
    GET_ORDER_INFO,
    GET_ORDER_COUPON,
    GENERATE_TOKEN,
    CANCEL_ORDER,
    GET_ORDER_UNREAD_MESSAGE,
    GET_ORDER_INFO_FOR_ORDER_NO,
    GET_ORDER_MESSAGE_LIST,
    USER_COMPLAINT_PLATFORM,
    GET_MOVIE_SCENE_INFO,
} from 'api';
import {
    PAGE_CUSTOMER_SERVICE,
    PAGE_TABBAR_DEFAULT_REDIRECT,
    PAGE_ROOT,
    PAGE_ORDER_INFO,
    PAGE_PAY,
    PAGE_TICKET_TYPE,
} from 'page';
import pay from 'pay';
let PAGE_GUID = '';
let couponSwiper;

export default {
    data() {
        return {
            id: '',
            orderNo: '',
            status: '',
            detail: {},
            couponImgs: [],
            imgCurrent: 0,
            previewImageList: [],
            previewImageIndex: 0,
            showImgStatus: false,
            showCancelStatus: false,
            pickerList: [
                {
                    id: 0,
                    name: '不想看了',
                },
                {
                    id: 1,
                    name: '太贵了',
                },
                {
                    id: 2,
                    name: '其他',
                },
            ],
            pickerKey: 'name',
            unReadNum: 0,
            chatStatus: false,
            chatList: [],
            chatValue: '',
            cssText: '',
            isNextGetData: false,
            // 返回首页按钮
            showHome: false,
            // 支付倒计时
            payDownTimer: null,
            payDownTime: 0,
            payDownTimeText: null,
            updatePageTimer: null,
            showPopupStatus: false,
            showPriceDetail: false,
            // 页面更新时间
            pageUpdateTime: null,
            // 是否需要登录
            noLogin: false,
        };
    },
    components: {
        previewImage,
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from && from.path == PAGE_TABBAR_DEFAULT_REDIRECT && from.query.backType == 2) {
                if (vm.$store.getters.isWechatMin) {
                    wx.miniProgram.navigateBack({
                        delta: 1,
                    });
                } else {
                    for (let i = 100; i > 0; i--) {
                        window.history.go(-i);
                    }
                }
            }
            PAGE_GUID = vm.$util.guid();
        });
    },
    created() {
        this.$util.loading();
        this.noLogin = this.$route.query.noLogin || false;
        this.id = this.$route.query.orderId;
        this.orderNo = this.$route.query.orderNo;
        this.status = this.$route.query.status;
        this.showHome = this.$route.query.showHome == 'true';
        this.getOrderInfo();
        this.isNextGetData = false;
        if (this.$route.query.backIndex) {
            this.fobiddeBack();
        } else {
            this.enableBack();
        }
    },
    beforeDestroy() {
        clearInterval(this.payDownTimer);
    },
    methods: {
        payOrder() {
            if (this.detail.userMobile) {
                return pay({
                    orderType: 5,
                    orderId: this.detail.id,
                    orderNo: this.detail.orderNo,
                    // returnUrl: `${window.location.origin}${PAGE_ORDER_INFO}?orderId=${this.detail.id}&orderNo=${this.detail.orderNo}&orderType=5`
                }).then(payRes => {
                    if (payRes.success) {
                    } else {
                        this.$toast(payRes.message);
                    }
                });
            }
            if (!this.$store.state.common.config.enableFastDrawMode) {
                this.$util.pageJump(PAGE_PAY, {
                    orderNo: this.detail.orderNo,
                });
            } else {
                this.$util
                    .post(GET_MOVIE_SCENE_INFO, {
                        showId: this.detail.showId,
                    })
                    .then(res => {
                        if (res.success) {
                            this.$util.pageJump(PAGE_TICKET_TYPE, {
                                orderNo: this.detail.orderNo,
                                // 特惠出票模式是否开启
                                ecm: res.data.enableCompetitionMode,
                                // 直接购票模式是否开启
                                efdm: res.data.enableFastDrawMode,
                                // 特惠出票的原因   1:开场时间    2:限流
                                dcmt: res.data.disableCompetitionModeType,
                                // 限流分钟数
                                cmri: res.data.competitionModeReleaseInterval,
                            });
                        }
                    });
            }
        },
        showTip() {
            this.showPopupStatus = true;
        },
        hideTip() {
            this.showPopupStatus = false;
        },
        switchDetail() {
            this.showPriceDetail = !this.showPriceDetail;
        },
        // 拓展方法
        clickExpand(name) {
            if (name == 'QiShiKa' && this.$store.getters.getExposeMethod.recurrenceConfirmOption) {
                this.$confirm.open(this.$store.getters.getExposeMethod.recurrenceConfirmOption);
            }
        },
        // 获取订单信息
        getOrderInfo() {
            if (this.id) {
                this.$util
                    .get(`${GET_ORDER_INFO}/${this.id}?time=${new Date().getTime()}`)
                    .then(res => {
                        if (res.success) {
                            this.orderInfoResNext(res);
                        }
                    });
            } else if (this.orderNo) {
                this.$util
                    .get(GET_ORDER_INFO_FOR_ORDER_NO, {
                        time: new Date().getTime(),
                        orderNo: this.orderNo,
                    })
                    .then(res => {
                        if (res.success) {
                            this.orderInfoResNext(res);
                        }
                    });
            }
        },
        orderInfoResNext(res) {
            try {
                this.pageUpdateTime = moment().format('YYYY-MM-DD HH:mm:ss');
                this.$util.unloading();
                res.data.showDate = moment(res.data.showTime).format('M月D日');
                res.data.showTimeHM = moment(res.data.showTime).format('HH:mm');
                res.data.showEndTimeHM = moment(res.data.showEndTime).format('HH:mm');
                this.detail = res.data;
                this.getCouponList();
                this.setTitle();
                if (res.data.status == 0) {
                    this.payDownTime = this.detail.paymentExpireSeconds;
                    if (this.payDownTimer) {
                        clearInterval(this.payDownTimer);
                    }
                    if (this.payDownTime > 0) {
                        this.setPayTime();
                        this.payDownTimer = setInterval(() => {
                            if (this._isDestroyed) {
                                console.log('离开页面销毁数据', '停止计时器');
                                clearInterval(this.payDownTimer);
                                return;
                            }
                            this.payDownTime--;
                            this.setPayTime();
                            if (this.payDownTime == 0) {
                                clearInterval(this.payDownTimer);
                            }
                        }, 1000);
                    }
                    if (moment().format('X') - moment(res.data.createTime).format('X') < 5 * 60) {
                        if (this._isDestroyed) {
                            console.log('离开页面销毁数据', PAGE_GUID, res.data.id);
                            return;
                        }
                        console.log('准备拉取下一次数据', PAGE_GUID, res.data.id);
                        if (this.updatePageTimer) {
                            clearTimeout(this.updatePageTimer);
                        }
                        this.updatePageTimer = setTimeout(() => {
                            this.getOrderInfo();
                        }, 2000);
                    }
                } else if (res.data.status == 5) {
                    if (this._isDestroyed) {
                        console.log('离开页面销毁数据', PAGE_GUID, res.data.id);
                        return;
                    }
                    console.log('准备拉取下一次数据', PAGE_GUID, res.data.id);
                    if (this.updatePageTimer) {
                        clearTimeout(this.updatePageTimer);
                    }
                    this.updatePageTimer = setTimeout(() => {
                        this.getOrderInfo();
                    }, 5000);
                }
            } catch (error) {
                this.$toast('页面异常，请联系客服或者重新打开页面', 5000);
                this.getOrderInfo();
            }
        },
        setPayTime() {
            let tempPayDownTimeText = '';
            tempPayDownTimeText = this.repairZero(parseInt(this.payDownTime / 60)) + ':';
            tempPayDownTimeText += this.repairZero(this.payDownTime % 60);
            this.payDownTimeText = tempPayDownTimeText;
        },
        repairZero(n) {
            return (n < 10 ? '0' : '') + n;
        },
        setTitle() {
            let title = '';
            if (this.detail.status == 0) {
                title = '待支付';
            } else if (this.detail.status == -5) {
                title = '已取消';
            } else if (this.detail.status == 10) {
                title = '已出票';
            } else if (this.detail.status == 15) {
                title = '已完成';
            } else if (this.detail.status == 5 && !this.detail.supplierId) {
                title = '排队中';
            } else if (this.detail.status == 5 && this.detail.supplierId) {
                title = '出票中';
            }
            this.$util.setTitleName(title);
        },
        // 获取优惠券列表
        getCouponList() {
            this.$util
                .post(GET_ORDER_COUPON, { orderNo: this.orderNo || this.detail.orderNo })
                .then(res => {
                    if (res.success) {
                        this.couponImgs = res.data;
                        this.previewImageList = [];
                        for (let i = 0; i < this.couponImgs.length; i++) {
                            const item = this.couponImgs[i];
                            this.previewImageList.push(item.couponCodeImageUrl);
                        }
                        this.$nextTick(() => {
                            if (this.previewImageList.length == 1) {
                                return;
                            }
                            couponSwiper = new Swiper('.coupon-swiper', {
                                direction: 'horizontal' /*横向滑动*/,
                                onSlideChangeEnd: swiper => {
                                    this.imgCurrent = swiper.activeIndex;
                                },
                            });
                        });
                    }
                });
        },
        // 获取未读消息
        getOrderUnreadMsg() {
            this.$util.get(`${GET_ORDER_UNREAD_MESSAGE}/${this.id || this.detail.id}`).then(res => {
                if (res.success) {
                    this.unReadNum = res.data;
                }
            });
        },
        // 上一张
        prev() {
            if (couponSwiper) {
                couponSwiper.slidePrev();
            }
        },
        // 下一张
        next() {
            if (couponSwiper) {
                couponSwiper.slideNext();
            }
        },
        // 成功复制
        copySuccess() {
            this.$toast('复制成功');
        },
        // 全屏预览图片
        showPreviewImage(item, index) {
            this.previewImageIndex = index;
            this.showImgStatus = true;
        },
        // 预览改变
        previewImageChange(data) {
            if (data.close) {
                this.showImgStatus = false;
            }
        },
        // 点击取消订单
        cancelOrder() {
            let msg =
                this.detail.drawMode == 0
                    ? `您的优惠购票正在出票中，一旦取消会被其他用户抢占哦~您确定要放弃吗？`
                    : `您锁定的座位正在出票中，一旦放弃会被其他用户抢占哦~确定要放弃吗？`;
            this.$confirm.open({
                title: '温馨提示',
                message: msg,
                confirmText: '我再想想',
                cancelText: '忍痛取消',
                error: res => {
                    this.$picker.open({
                        list: this.pickerList,
                        keyName: this.pickerKey,
                        confirm: item => {
                            this.pickerConfirm(item);
                        },
                    });
                },
            });
        },
        // 确定
        pickerConfirm(item) {
            this.$picker.close();
            this.$util.get(GENERATE_TOKEN).then(tokenRes => {
                if (tokenRes.success) {
                    this.$util
                        .post(`${CANCEL_ORDER}/${this.id || this.detail.id}`, {
                            refundCause: item.name,
                            token: tokenRes.data.token,
                        })
                        .then(res => {
                            if (res.success) {
                                this.$toast('订单已取消');
                                this.getOrderInfo();
                            }
                        });
                }
            });
        },
        // 投诉
        complaint() {
            this.$util
                .get(USER_COMPLAINT_PLATFORM, {
                    orderNo: this.detail.orderNo,
                })
                .then(res => {
                    if (res.success) {
                        window.location.href = res.data.url;
                    }
                });
        },
        // 催单
        reminder() {
            setTimeout(() => {
                this.$toast('催单成功！订单会加急处理哦，请耐心等待~');
            }, 200);
        },
        // 联系客服
        contact() {
            this.$util.pageJump(PAGE_CUSTOMER_SERVICE, {
                orderNo: this.detail.orderNo,
                noLogin: this.noLogin,
            });
        },
        toHome() {
            this.$util.pageJump({
                path: PAGE_ROOT,
                config: {
                    jumpType: 1,
                },
            });
        },
        // 刷新页面
        refresh() {
            this.$store.commit('reloadApp');
            // window.location.reload();
        },
        //防止页面后退
        fobiddeBack() {
            if (!this.isOpenBack) {
                console.log('%c防止页面后退', 'color:#da2f33');
                this.isOpenBack = true;
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.backCommon);
            }
        },
        //启用浏览器返回
        enableBack() {
            if (this.isOpenBack) {
                console.log('%c启用浏览器返回', 'color:#da2f33');
                this.isOpenBack = false;
                history.go(-1);
                window.removeEventListener('popstate', this.backCommon);
            }
        },
        backCommon() {
            if (this.$route.path != PAGE_ORDER_INFO) {
                try {
                    if (this.$store.getters.isApp) {
                        let returnObj = JSON.parse(
                            this.$store.state.common.config.app.exposeMethodName
                        );
                        if (returnObj.type == 2) {
                            window.location.href = returnObj.url;
                        }
                    }
                } catch (error) {}
            } else {
                if (this.$route.query.backIndex) {
                    if (this.$route.query.backIndexType == 1) {
                        setTimeout(() => {
                            this.isOpenBack = false;
                            window.removeEventListener('popstate', this.backCommon);
                        }, 100);
                        this.$util.pageJump(PAGE_ROOT, {
                            backType: 2,
                        });
                    } else {
                        this.enableBack();
                        setTimeout(() => {
                            window.history.go(-3);
                        }, 100);
                    }
                }
                history.pushState(null, null, document.URL);
            }
        },
    },
};
</script>
<style>
.picker .picker-items .cancel-order-picker {
    width: 100vw !important;
}
</style>

<style lang="less" scoped>
@import url('~@/lib/base.less');
.order-info {
    position: relative;
    min-height: 100vh;
    overflow-x: hidden;
    background: @theme_color_first;
    .order-detail {
        background: white;
        margin: .pxToRem(20) [] .pxToRem(30) [];
        border-radius: .pxToRem(40) [];
    }
    .session-info {
        padding: 0 .pxToRem(30) [];
        box-sizing: border-box;
        .line-cinema {
            line-height: .pxToRem(40) [];
            font-size: .pxToRem(28) [];
            color: rgba(0, 0, 0, 0.9);
            padding-top: .pxToRem(32) [];
            padding: .pxToRem(32) [] 0 .pxToRem(28) [];
            font-weight: 600;
            border-bottom: .pxToRem(1) [] solid rgba(0, 0, 0, 0.15);
            .overflow();
        }
        .line-film-name {
            margin-top: .pxToRem(24) [];
            line-height: .pxToRem(40) [];
            font-size: .pxToRem(40) [];
            font-weight: 600;
            color: rgba(0, 0, 0, 0.9);
        }
        .line-version-type {
            margin-top: .pxToRem(20) [];
            line-height: .pxToRem(36) [];
            font-size: .pxToRem(24) [];
            font-weight: 400;
            color: rgba(0, 0, 0, 0.9);
        }
        .info-box {
            display: flex;
            width: 100%;
            margin-top: .pxToRem(50) [];
            .time {
                width: .pxToRem(200) [];
                .line-show-date {
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.9);
                }
                .line-show-time {
                    margin-top: .pxToRem(4) [];
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(28) [];
                    font-weight: 600;
                    color: rgba(0, 0, 0, 0.9);
                }
            }
            .seat {
                flex: 1;
                .line-hall-name {
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.9);
                }
                .seat-list {
                    &.mini {
                        font-size: .pxToRem(22) [];
                        color: rgba(0, 0, 0, 0.5);
                        .seat-item {
                            font-size: .pxToRem(22) [];
                            color: rgba(0, 0, 0, 0.5);
                            text-decoration: line-through;
                        }
                    }
                }
                .seat-item {
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.8);
                    &::after {
                        content: ',';
                    }
                    &:last-child {
                        &::after {
                            content: '';
                        }
                    }
                }
            }
        }
        .film-img {
            position: absolute;
            top: .pxToRem(117) [];
            right: .pxToRem(30) [];
            width: .pxToRem(112) [];
            height: .pxToRem(149) [];
            border-radius: .pxToRem(16) [];
        }
    }
    .dividing-line {
        height: .pxToRem(40) [];
        .line-item {
            .base-center;
            width: .pxToRem(630) [];
            height: .pxToRem(1) [];
            background: rgba(0, 0, 0, 0.15);
        }
        &::before {
            content: ' ';
            .base-center-y;
            left: 0;
            height: .pxToRem(36) [];
            width: .pxToRem(18) [];
            background: @theme_color_first;
            border-top-right-radius: .pxToRem(18) [];
            border-bottom-right-radius: .pxToRem(18) [];
        }
        &::after {
            content: ' ';
            .base-center-y;
            right: 0;
            height: .pxToRem(36) [];
            width: .pxToRem(18) [];
            background: @theme_color_first;
            border-top-left-radius: .pxToRem(18) [];
            border-bottom-left-radius: .pxToRem(18) [];
        }
    }
    .tip-list {
        display: flex;
        padding: .pxToRem(0) [] .pxToRem(64) [] 0 .pxToRem(30) [];
        height: .pxToRem(76) [];
        line-height: .pxToRem(76) [];
        justify-content: space-between;
        align-items: center;
        .tip-item {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #d90209;
            img {
                .sq(32);
            }
            span {
                margin-left: .pxToRem(10) [];
            }
            &:last-child {
                color: rgba(0, 0, 0, 0.9);
                font-weight: bold;
            }
        }
        &:before {
            content: ' ';
            position: absolute;
            top: .pxToRem(26) [];
            right: .pxToRem(30) [];
            .sq(24);
            background: url(~@/assets/icons/icon-right.png);
            background-size: cover;
        }
    }
    .popup {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 450;
        .tip-message {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
            border-top-left-radius: .pxToRem(40) [];
            border-top-right-radius: .pxToRem(40) [];
            .title {
                height: .pxToRem(106) [];
                line-height: .pxToRem(106) [];
                text-align: center;
                font-size: .pxToRem(32) [];
                font-weight: bold;
                color: rgba(0, 0, 0, 0.9);
                &:after {
                    content: ' ';
                    position: absolute;
                    bottom: 0;
                    left: .pxToRem(50) [];
                    right: .pxToRem(50) [];
                    height: .pxToRem(1) [];
                    background: rgba(0, 0, 0, 0.1);
                }
            }
            .content {
                padding: 0 .pxToRem(50) [];
                padding-bottom: .pxToRem(50) [];
                .bold {
                    margin-top: .pxToRem(30) [];
                    color: rgba(0, 0, 0, 0.9);
                }
                p {
                    margin-top: .pxToRem(10) [];
                    font-size: .pxToRem(28) [];
                    color: rgba(0, 0, 0, 0.5);
                    line-height: .pxToRem(44) [];
                }
            }
            .close {
                position: absolute;
                top: .pxToRem(37) [];
                right: .pxToRem(50) [];
                .sq(32);
            }
        }
    }

    .line {
        display: flex;
        justify-content: space-between;
        height: .pxToRem(60) [];
        line-height: .pxToRem(60) [];
        .line-title {
            font-size: .pxToRem(28) [];
            color: rgba(0, 0, 0, 0.9);
        }
        .line-value {
            display: flex;
            font-size: .pxToRem(30) [];
        }
        &.mobile {
            .line-value {
                .input {
                    text-align: right;
                }
            }
        }
        &.notice {
            .line-value {
                align-items: center;
                .section-img {
                    .sq(32);
                    margin-right: .pxToRem(16) [];
                }
            }
        }
    }

    .status-box {
        .update-time {
            margin-top: .pxToRem(20) [];
            margin-bottom: .pxToRem(-20) [];
            text-align: center;
            color: #999999;
            font-size: .pxToRem(24) [];
            .red {
                color: #eb5c5a;
                font-weight: bold;
            }
        }
        .btn-refresh {
            position: absolute;
            top: .pxToRem(10) [];
            right: .pxToRem(30) [];
            height: .pxToRem(60) [];
            line-height: .pxToRem(60) [];
            padding-left: .pxToRem(52) [];
            padding-right: .pxToRem(16) [];
            border: .pxToRem(1) [] solid #313131;
            border-radius: .pxToRem(30) [];
            color: rgba(0, 0, 0, 0.9);
            font-size: .pxToRem(26) [];
            &::before {
                content: ' ';
                .base-center-y;
                left: .pxToRem(14) [];
                width: .pxToRem(32) [];
                height: .pxToRem(32) [];
                background: url('~@/assets/icons/icon-rotate.png');
                background-size: contain;
            }
        }
    }

    .status-box:not(.status-10):not(.status-15) {
        display: flex;
        align-items: center;
        flex-direction: column;
        .status-circular {
            margin-top: .pxToRem(30) [];
            .sq(180);
            border-radius: .pxToRem(90) [];
            box-sizing: border-box;
            &::after {
                content: ' ';
                .base-center;
                .sq(64);
            }
        }
        .status-title {
            margin-top: .pxToRem(10) [];
            height: .pxToRem(56) [];
            line-height: .pxToRem(56) [];
            font-size: .pxToRem(34) [];
            color: rgba(0, 0, 0, 0.9);
        }
        .btn {
            height: .pxToRem(60) [];
            line-height: .pxToRem(60) [];
            padding: 0 .pxToRem(30) [];
            border-radius: .pxToRem(30) [];
            color: rgba(0, 0, 0, 0.9);
            margin-top: .pxToRem(30) [];
            background: @theme_color_first;
        }
        &.status--5 {
            padding-bottom: .pxToRem(24) [];
            .status-circular {
                background: #f2f2f2;
                border: .pxToRem(1) [] solid #d9d9d9;
                &::after {
                    background: url('~@/assets/icons/icon-order-status--5.png');
                    background-size: cover;
                }
            }
        }
        &.status-0 {
            padding-bottom: .pxToRem(36) [];
            .status-circular {
                text-align: center;
                line-height: .pxToRem(180) [];
                background: #fdf0f0;
                border: .pxToRem(1) [] solid #d90209;
                font-size: .pxToRem(40) [];
                font-weight: bold;
                color: #d90209;
            }
            .status-title {
                color: #d90209;
            }
        }
        &.status-5 {
            padding-bottom: .pxToRem(34) [];
            .status-circular {
                background: #e1f9ec;
                border: .pxToRem(1) [] solid #a6e1c1;
                &::after {
                    background: url('~@/assets/icons/icon-order-status-5.png');
                    background-size: cover;
                }
            }
        }
    }

    .status-box.status-10,
    .status-box.status-15 {
        padding: 0 .pxToRem(30) [];
        padding-bottom: .pxToRem(30) [];
        display: flex;
        align-items: center;
        flex-direction: column;
        .status-title {
            margin-top: .pxToRem(10) [];
            width: 100%;
            text-align: left;
            height: .pxToRem(60) [];
            line-height: .pxToRem(60) [];
            font-size: .pxToRem(40) [];
            font-weight: bold;
            color: rgba(0, 0, 0, 0.9);
        }
        .status-tip {
            margin-top: .pxToRem(10) [];
            width: 100%;
            text-align: left;
            color: rgba(0, 0, 0, 0.5);
            height: .pxToRem(38) [];
            line-height: .pxToRem(38) [];
        }
        .swiper {
            margin-top: .pxToRem(30) [];
            width: 100%;
            .coupon-swiper {
                width: .pxToRem(520) [];
                border: .pxToRem(2) [] dashed #d9d9d9;
                border-radius: .pxToRem(40) [];
                .swiper-slide {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    .swiper-img {
                        margin: .pxToRem(20) [];
                        max-width: .pxToRem(360) [];
                        max-height: .pxToRem(360) [];
                    }
                    .code-info {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        height: .pxToRem(140) [];
                        border-top: .pxToRem(1) [] solid rgba(0, 0, 0, 0.15);
                        .item {
                            flex: 1;
                            .value,
                            .title {
                                width: 100%;
                                text-align: center;
                            }
                            .value {
                                height: .pxToRem(40) [];
                                line-height: .pxToRem(40) [];
                                font-size: .pxToRem(30) [];
                                color: rgba(0, 0, 0, 0.9);
                                margin-top: .pxToRem(30) [];
                                font-weight: bold;
                            }
                            .title {
                                font-size: .pxToRem(24) [];
                                color: rgba(0, 0, 0, 0.5);
                                line-height: .pxToRem(38) [];
                                margin-top: .pxToRem(2) [];
                            }
                            &::after {
                                content: ' ';
                                position: absolute;
                                top: .pxToRem(30) [];
                                right: .pxToRem(0) [];
                                bottom: .pxToRem(30) [];
                                width: .pxToRem(1) [];
                                background: rgba(0, 0, 0, 0.15);
                            }
                            &:last-child {
                                &::after {
                                    content: '';
                                    width: 0;
                                }
                            }
                        }
                    }
                    .seat-text {
                        width: 100%;
                        text-align: center;
                        background: rgba(0, 0, 0, 0.05);
                        height: .pxToRem(78) [];
                        line-height: .pxToRem(78) [];
                    }
                }
            }
            .swiper-arrow {
                .base-center-y;
                .sq(32);
                &.prevs {
                    left: 0;
                    transform: translateY(-50%) rotate(180deg);
                    background: url('~@/assets/icons/icon-right.png');
                    background-size: cover;
                }
                &.nexts {
                    right: 0;
                    background: url('~@/assets/icons/icon-right.png');
                    background-size: cover;
                }
            }
        }
        .indicator-text {
            height: .pxToRem(40) [];
            line-height: .pxToRem(40) [];
            margin-top: .pxToRem(24) [];
            font-size: .pxToRem(26) [];
            font-weight: 400;
            color: rgba(0, 0, 0, 0.9);
            .prominent {
                line-height: .pxToRem(56) [];
                font-size: .pxToRem(40) [];
                font-weight: 600;
                color: #d90209;
            }
        }
        .seal {
            position: absolute;
            top: .pxToRem(-13) [];
            left: .pxToRem(85) [];
            .sq(160);
            z-index: 100;
        }
    }
    .status-box.status-15 {
        .swiper-container {
            opacity: 0.25;
        }
    }

    .model {
        padding: 0 .pxToRem(30) [];
        &.price {
            height: .pxToRem(100) [];
            overflow: hidden;
            transition: all 0.3s;
            .title {
                height: .pxToRem(100) [];
                line-height: .pxToRem(100) [];
                .line-title,
                .line-value {
                    color: rgba(0, 0, 0, 0.9);
                }
                .line-title {
                    font-size: .pxToRem(40) [];
                }
                .line-value {
                    font-size: .pxToRem(28) [];
                    padding-right: .pxToRem(52) [];
                    &::after {
                        content: ' ';
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%) rotate(-90deg);
                        .sq(32);
                        background: url(~@/assets/icons/icon-down.png);
                        background-size: cover;
                        transition: all 0.3s;
                    }
                }
            }
            &.open {
                height: auto;
                // height: auto;
                padding-bottom: .pxToRem(20) [];
                .title {
                    .line-value {
                        &::after {
                            transform: translateY(-50%) rotate(0deg);
                        }
                    }
                }
            }
        }
        &.information {
            .line {
                padding: .pxToRem(9) [] 0;
                .line-value {
                    font-size: .pxToRem(28) [];
                    .copy {
                        margin-left: .pxToRem(20) [];
                        color: rgba(0, 0, 0, 0.9);
                    }
                }
            }
            .btn-list {
                justify-content: flex-end;
                padding-top: .pxToRem(16) [];
                padding-bottom: .pxToRem(32) [];
                .btn {
                    height: .pxToRem(60) [];
                    line-height: .pxToRem(60) [];
                    padding: 0 .pxToRem(24) [];
                    color: rgba(0, 0, 0, 0.9);
                    border: 1px solid #313131;
                    border-radius: .pxToRem(30) [];
                    margin-right: .pxToRem(20) [];
                    white-space: nowrap;
                    &.contact {
                        color: #eb5c5a;
                        border: 1px solid #eb5c5a;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
    }

    .keynote {
        color: #d90209;
    }
    .secondary {
        color: rgba(0, 0, 0, 0.5);
    }
    .section-content {
        color: rgba(0, 0, 0, 0.6);
    }
}

.filme-another {
    display: flex;
    justify-content: flex-end;
    margin-top: .pxToRem(10) [];
}
.filme-commission {
    font-size: .pxToRem(22) [];
    color: #000000;
    margin-left: .pxToRem(10) [];
    &-num {
        font-size: .pxToRem(24) [];
        color: #ff1e1e;
    }
}
.show-home {
    position: fixed;
    bottom: .pxToRem(316) [];
    left: .pxToRem(0) [];
    height: .pxToRem(56) [];
    line-height: .pxToRem(56) [];
    background: #eb5c5a;
    padding-left: .pxToRem(20) [];
    font-size: .pxToRem(24) [];
    padding-right: .pxToRem(30) [];
    border-radius: 0 .pxToRem(28) [] .pxToRem(28) [] 0;
    color: white;
}
</style>
